import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export enum DiscountType {
    Amount = 'Amount',
    Percent = 'Percent'
}
export interface PromotionalCode {
    id?: string;
    status: boolean;
    code: string;
    noLimit: boolean;
    usageLimit: number;
    branchOfficesAvailable: string[];
    discountType: DiscountType;
    discountValue: number;
    /** Sello de creación (F6): el admin de sucursal crea los de su sucursal. */
    createdAt?: any;
    createdBy?: { uid: string; name: string };
    // Show data
    usage?: number;
    usageAmount?: number;
}
export const PROMOTIONAL_CODES_COLLECTION = 'promotional_codes';

export const promotionalCodesRef = collection(firestore, PROMOTIONAL_CODES_COLLECTION);
